import axios from 'axios';
import Link from 'components/links/Link';
import { Form, Formik } from 'formik';
import { NextSeo } from 'next-seo';
import React, { useState } from 'react';
import { Send } from 'react-feather';
import * as Yup from 'yup';

import Button from '../components/buttons/Button';
import Footer from '../components/Footer';
import InputField from '../components/forms/fields/InputField';
import TextareaField from '../components/forms/fields/TextareaField';
import documents from '../config/documents';
import pages from '../config/pages';

function ContactPage() {
    const [isPosting, setIsPosting] = useState(false);
    const [isSuccess, setSuccess] = useState(false);

    return (
        <div className="single-page pt-12 flex flex-col justify-between 3xl:h-[95vh]" id="kontakt">
            <NextSeo title={pages.contact.title} description={pages.contact.seo.description} />
            <div>
                <div className="text-center container">
                    <h1 className="text-uppercase text-brand">Piši nam</h1>
                    <p className="mt-4 max-w-xl mx-auto">
                        KZV-jevci smo vedno odprti za predloge, pa tudi za nova sodelovanja ali za odgovore na tvoja
                        vprašanja. Odgovorili bomo v najkrajšem možnem času.
                    </p>
                </div>
                <Formik
                    initialValues={{
                        name: '',
                        email: '',
                        message: ''
                    }}
                    validationSchema={Yup.object().shape({
                        name: Yup.string().max(255).required('Vnesi tvoje ime.'),
                        message: Yup.string().required('Vnesi sporočilo.'),
                        email: Yup.string()
                            .email('Vnesi veljaven e-poštni naslov.')
                            .max(255)
                            .required('Vnesi e-poštni naslov.')
                    })}
                    onSubmit={async (values, { resetForm }) => {
                        setIsPosting(true);

                        try {
                            await axios.post('/api/contact', {
                                ...values
                            });
                            resetForm();
                            setIsPosting(false);
                            setSuccess(true);
                        } catch (error) {
                            setIsPosting(false);
                        }
                    }}
                >
                    {({ errors, handleBlur, handleChange, touched, values }) => (
                        <Form className="mt-14 max-w-4xl mx-auto container">
                            <div className="md:grid grid-cols-12 gap-8">
                                <div className="col-span-4">
                                    <div className="space-y-4">
                                        <div className="input-wrap">
                                            <InputField
                                                value={values.name}
                                                label="Ime in priimek"
                                                error={Boolean(touched.name && errors.name)}
                                                helperText={touched.name && errors.name}
                                                type="text"
                                                name="name"
                                                placeholder="Vnesi svoje ime"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        <div className="input-wrap">
                                            <InputField
                                                value={values.email}
                                                error={Boolean(touched.email && errors.email)}
                                                helperText={touched.email && errors.email}
                                                type="email"
                                                name="email"
                                                label="E-poštni naslov"
                                                placeholder="Vnesi svoj e-poštni naslov"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-span-8">
                                    <div className="mt-4 md:mt-0 input-wrap">
                                        <TextareaField
                                            value={values.message}
                                            error={Boolean(touched.message && errors.message)}
                                            helperText={touched.message && errors.message}
                                            name="message"
                                            label="Sporočilo"
                                            className="h-24 border-gray-500"
                                            placeholder="Vnesi sporočilo"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-between sm:mt-8 flex-col sm:flex-row">
                                <p className="text-xs text-secondary">
                                    Osebne podatke obdelujemo samo za potrebe priprave odgovora. <br />
                                    Več o obdelavi si preberite v naši{' '}
                                    <Link styles="underline" to={documents.privacy}>
                                        politiki zasebnosti
                                    </Link>
                                    .
                                </p>
                                <div className="text-right mt-4 sm:mt-0">
                                    {isSuccess && (
                                        <p className="text-brand font-semibold mb-4">
                                            Sporočilo uspešno poslano. Odgovorili vam bomo v najkrajšem možnem času.
                                        </p>
                                    )}
                                    <Button type="submit" color="secondary" endIcon={<Send />} disabled={isPosting}>
                                        Pošlji sporočilo
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>

            <div className="mt-24">
                <Footer />
            </div>
        </div>
    );
}

export default ContactPage;
